import api from "../../api/api";
import { toast } from "react-toastify";
import {
  ADD_REQUEST_REQUEST,
  ADD_REQUEST_SUCCESS,
  ADD_REQUEST_FAILURE,
  FETCH_REQUESTS_REQUEST,
  FETCH_REQUESTS_SUCCESS,
  FETCH_REQUESTS_FAILURE,
  FETCH_PENDING_UPLOAD_REQUESTS_REQUEST,
  FETCH_PENDING_UPLOAD_REQUESTS_SUCCESS,
  FETCH_PENDING_UPLOAD_REQUESTS_FAILURE,
  FETCH_PENDING_APPROVAL_REQUESTS_REQUEST,
  FETCH_PENDING_APPROVAL_REQUESTS_SUCCESS,
  FETCH_PENDING_APPROVAL_REQUESTS_FAILURE,
  FETCH_REQUEST_TYPES_REQUEST,
  FETCH_REQUEST_TYPES_SUCCESS,
  FETCH_REQUEST_TYPES_FAILURE,
  FETCH_REQUEST_DETAILS,
  FETCH_REQUEST_DETAILS_SUCCESS,
  FETCH_REQUEST_DETAILS_FAILURE,
  FETCH_REQUEST_PAYMENT_CODE,
  FETCH_REQUEST_PAYMENT_CODE_SUCCESS,
  FETCH_REQUEST_PAYMENT_CODE_FAILURE,
  RESET_PAYMENT_CODE_DETAILS,
  UPDATE_REQUEST_REQUEST,
  UPDATE_REQUEST_SUCCESS,
  UPDATE_REQUEST_FAILURE,
  DELETE_REQUEST_REQUEST,
  DELETE_REQUEST_SUCCESS,
  DELETE_REQUEST_FAILURE,
  UPLOAD_RECEIPT_REQUEST,
  UPLOAD_RECEIPT_SUCCESS,
  UPLOAD_RECEIPT_FAILURE,
  FETCH_RECEIPT_REQUEST,
  FETCH_RECEIPT_SUCCESS,
  FETCH_RECEIPT_FAILURE,
  APPROVE_RECEIPT_REQUEST,
  APPROVE_RECEIPT_SUCCESS,
  APPROVE_RECEIPT_FAILURE,
  REQUIRE_RECEIPT_REQUEST,
  REQUIRE_RECEIPT_SUCCESS,
  REQUIRE_RECEIPT_FAILURE,
  RECALL_REQUEST_REQUEST,
  RECALL_REQUEST_SUCCESS,
  RECALL_REQUEST_FAILURE,
  CLEAR_REQUESTS_ERROR,
} from "./requestActionTypes";

// Map requestType to respective API endpoints
const requestTypeRoutes = {
  "Payment Voucher": "/PaymentVoucher",
  "Salary Advance": "/SalaryAdvance",
  Loan: "/Loan",
  Executive: "/Executive",
};

const normalizeRequestType = (requestType) => {
  if (requestType === "Executive Request") return "Executive";
  return requestType;
};

/*const handleError = (error, context) => {
  console.error(`API - ${context} error:`, error);
  if (error.response) {
    const { status, data } = error.response;
    switch (status) {
      case 400:
        return data.message || "Bad request. Please check your input.";
      case 401:
        localStorage.clear();
        window.location.href = "/";
        return "Session expired. Please log in again.";
      case 403:
        return "You do not have permission to perform this action.";
      case 404:
        return;
        "Requested resource not found.";
      case 409:
        return data.message || "Request already exists.";
      case 500:
        return "Server error. Please try again later.";
      default:
        return data.message || "An unknown error occurred.";
    }
  }
  if (error.request) {
    return "No response received from the server. Please try again later.";
  }
  return error.message || "An unknown error occurred.";
};
*/

const handleError = (error, context) => {
  console.error(`API - ${context} error:`, error);
  if (error.response) {
    const { status, data } = error.response;
    switch (status) {
      case 400:
        return data.message || "Bad request. Please check your input.";
      case 401:
        localStorage.clear();
        window.location.href = "/";
        return "Session expired. Please log in again.";
      case 403:
        return "You do not have permission to perform this action.";
      case 404:
        return "No requests found for this user. Please try again.";
      case 409:
        return data.message || "Request already exists.";
      case 500:
        return "Server error. Please try again later.";
      default:
        return data.message || "An unknown error occurred.";
    }
  }
  if (error.request) {
    return "No response received from the server. Please try again later.";
  }
  return error.message || "An unknown error occurred.";
};

export const addRequest = (requestData) => async (dispatch) => {
  dispatch({ type: ADD_REQUEST_REQUEST });
  const requestBody = {
    requestTypeId: requestData.requestType,
    projectId: requestData.project,
    purposeId: requestData.purpose,
    amount: requestData.amount,
    description: requestData.description || "",
  };

  try {
    console.log("API - addRequest with body:", requestBody);
    const response = await api.post("/Accounts/register", requestBody);
    console.log("API - addRequest response:", response.data);
    dispatch({ type: ADD_REQUEST_SUCCESS, payload: response.data });
    toast.success("Request created successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "addRequest");
    dispatch({ type: ADD_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchPendingReceiptUploads = () => async (dispatch) => {
  dispatch({ type: FETCH_PENDING_UPLOAD_REQUESTS_REQUEST });
  try {
    console.log("API - fetchPendingReceiptUploadss");
    const response = await api.get("/RequestSetting/pending-receipts", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    console.log("API - fetchPendingReceiptUploads response:", response.data);
    dispatch({
      type: FETCH_PENDING_UPLOAD_REQUESTS_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "fetchPendingReceiptUploads");
    dispatch({
      type: FETCH_PENDING_UPLOAD_REQUESTS_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchPendingReceiptApprovals = () => async (dispatch) => {
  dispatch({ type: FETCH_PENDING_APPROVAL_REQUESTS_REQUEST });
  try {
    console.log("API - fetchPendingReceiptApprovals");
    const response = await api.get(
      "/RequestSetting/pending-receipt-approvals",
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      },
    );
    console.log("API - fetchPendingReceiptApprovals response:", response.data);
    dispatch({
      type: FETCH_PENDING_APPROVAL_REQUESTS_SUCCESS,
      payload: response.data,
    });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "fetchPendingReceiptApprovals");
    dispatch({
      type: FETCH_PENDING_APPROVAL_REQUESTS_FAILURE,
      payload: errorMessage,
    });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchRequests = () => async (dispatch) => {
  dispatch({ type: FETCH_REQUESTS_REQUEST });
  try {
    console.log("API - fetchRequests");
    const response = await api.get("/RequestSetting/unified-requests", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    console.log("API - fetchRequests response:", response.data);
    dispatch({ type: FETCH_REQUESTS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "fetchRequests");
    dispatch({ type: FETCH_REQUESTS_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

/*export const fetchRequestsById = () => async (dispatch) => {
  dispatch({ type: FETCH_REQUESTS_REQUEST });
  try {
    const userId = localStorage.getItem("userId");
    console.log("API - fetchRequestsById for userId:", userId);
    const response = await api.get(
      `/RequestSetting/unified-requests/${userId}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      },
    );
    console.log("API - fetchRequestsById response:", response.data);
    dispatch({ type: FETCH_REQUESTS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "fetchRequestsById");
    dispatch({ type: FETCH_REQUESTS_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};
*/

export const fetchRequestsById = () => async (dispatch) => {
  dispatch({ type: FETCH_REQUESTS_REQUEST });
  try {
    const userId = localStorage.getItem("userId");
    if (!userId) {
      throw new Error("User ID is missing. Please log in again.");
    }
    console.log("API - fetchRequestsById for userId:", userId);
    const response = await api.get(
      `/RequestSetting/unified-requests/${userId}`,
      {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      },
    );
    console.log("API - fetchRequestsById response:", response.data);
    dispatch({ type: FETCH_REQUESTS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "fetchRequestsById");
    console.error("API - fetchRequestsById error:", errorMessage);
    dispatch({
      type: FETCH_REQUESTS_FAILURE,
      payload: errorMessage,
    });
    if (errorMessage) {
      toast.error(errorMessage);
    }
    return null; // Allow UI to handle empty state
  }
};

export const fetchPendingRequestsById = () => async (dispatch) => {
  dispatch({ type: FETCH_REQUESTS_REQUEST });
  try {
    const userId = localStorage.getItem("userId");
    console.log("API - fetchPendingRequestsById for userId:", userId);
    const response = await api.get(`/RequestSetting/pending/${userId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    console.log("API - fetchPendingRequestsById response:", response.data);
    dispatch({ type: FETCH_REQUESTS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "fetchPendingRequestsById");
    dispatch({ type: FETCH_REQUESTS_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchRequestTypes = () => async (dispatch) => {
  dispatch({ type: FETCH_REQUEST_TYPES_REQUEST });
  try {
    console.log("API - fetchRequestTypes");
    const response = await api.get("/RequestSetting/requestsType", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    console.log("API - fetchRequestTypes response:", response.data);
    dispatch({ type: FETCH_REQUEST_TYPES_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "fetchRequestTypes");
    dispatch({ type: FETCH_REQUEST_TYPES_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchPaymentRequests = () => async (dispatch) => {
  dispatch({ type: FETCH_REQUESTS_REQUEST });
  try {
    console.log("API - fetchPaymentRequests");
    const response = await api.get("/PaymentVoucher", {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    console.log("API - fetchPaymentRequests response:", response.data);
    dispatch({ type: FETCH_REQUESTS_SUCCESS, payload: response.data });
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "fetchPaymentRequests");
    dispatch({ type: FETCH_REQUESTS_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const fetchRequestDetails =
  (requestId, requestType) => async (dispatch) => {
    dispatch({ type: FETCH_REQUEST_DETAILS });
    const normalizedType = normalizeRequestType(requestType);
    console.log(
      "fetchRequestDetails - Request Type:",
      requestType,
      "Normalized:",
      normalizedType,
    );
    const endpoint = requestTypeRoutes[normalizedType];
    console.log(
      "fetchRequestDetails - Endpoint:",
      endpoint,
      "requestId:",
      requestId,
    );

    if (!endpoint) {
      const errorMessage = `Invalid request type: ${requestType}`;
      console.error(errorMessage);
      dispatch({ type: FETCH_REQUEST_DETAILS_FAILURE, payload: errorMessage });
      toast.error(errorMessage);
      return;
    }

    try {
      console.log(`API - fetchRequestDetails for ${endpoint}/${requestId}`);
      const response = await api.get(`${endpoint}/${requestId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      console.log("API - fetchRequestDetails response:", response.data);
      dispatch({ type: FETCH_REQUEST_DETAILS_SUCCESS, payload: response.data });
      return response.data;
    } catch (error) {
      const errorMessage = handleError(error, "fetchRequestDetails");
      dispatch({ type: FETCH_REQUEST_DETAILS_FAILURE, payload: errorMessage });
      toast.error("Failed to fetch request details: " + errorMessage);
      throw error;
    }
  };

export const fetchRequestPaymentCode =
  (requestId, requestType) => async (dispatch) => {
    dispatch({ type: FETCH_REQUEST_PAYMENT_CODE });
    const normalizedType = normalizeRequestType(requestType);
    console.log(
      "fetchRequestPaymentCode - Request Type:",
      requestType,
      "Normalized:",
      normalizedType,
    );
    const endpoint = requestTypeRoutes[normalizedType];
    console.log(
      "fetchRequestPaymentCode - Endpoint:",
      endpoint,
      "requestId:",
      requestId,
    );

    if (!endpoint) {
      const errorMessage = `Invalid request type: ${requestType}`;
      console.error(errorMessage);
      dispatch({
        type: FETCH_REQUEST_PAYMENT_CODE_FAILURE,
        payload: errorMessage,
      });
      toast.error(errorMessage);
      return;
    }

    try {
      console.log(`API - fetchRequestPaymentCode for ${endpoint}/${requestId}`);
      const response = await api.get(`${endpoint}/${requestId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "*/*",
        },
      });
      console.log("API - fetchRequestPaymentCode response:", response.data);
      dispatch({
        type: FETCH_REQUEST_PAYMENT_CODE_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } catch (error) {
      const errorMessage = handleError(error, "fetchRequestPaymentCode");
      dispatch({
        type: FETCH_REQUEST_PAYMENT_CODE_FAILURE,
        payload: errorMessage,
      });
      toast.error("Failed to fetch payment code: " + errorMessage);
      throw error;
    }
  };

export const resetPaymentCodeDetails = () => ({
  type: RESET_PAYMENT_CODE_DETAILS,
});

export const uploadRequestReceipt =
  (requestId, userId, files) => async (dispatch) => {
    dispatch({ type: UPLOAD_RECEIPT_REQUEST });
    try {
      if (!files || !Array.isArray(files) || files.length === 0) {
        throw new Error("No files provided for upload");
      }
      if (files.length > 1) {
        throw new Error("Only one file can be uploaded at a time");
      }
      const file = files[0];
      const formData = new FormData();
      formData.append("Files", file); // Matches Swagger
      formData.append("RequestId", requestId);
      formData.append("UserId", userId);

      for (let [key, value] of formData.entries()) {
        console.log(`API - uploadReceipt FormData: ${key}=${value}`);
      }
      console.log(
        "API - uploadReceipt URL: /api/documents/upload",
        "RequestId:",
        requestId,
        "UserId:",
        userId,
        "File:",
        file.name,
        file.type,
        file.size,
      );

      const response = await api.post("/api/documents/upload", formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
          Accept: "*/*",
        },
      });

      console.log("API - uploadReceipt response:", response.data);

      // Validate response.data
      if (!response.data) {
        throw new Error("Invalid API response: response.data is empty");
      }

      // Handle array response
      const data = Array.isArray(response.data)
        ? response.data[0]
        : response.data;
      if (!data || typeof data !== "object") {
        throw new Error("Invalid API response: expected an object");
      }

      const { id, receiptFilePath, uploadedOn } = data;
      if (!id || !receiptFilePath || !uploadedOn) {
        console.error("API - uploadReceipt missing fields:", {
          id,
          receiptFilePath,
          uploadedOn,
        });
        throw new Error(
          "API response missing required fields (id, receiptFilePath, uploadedOn)",
        );
      }

      const payload = {
        id,
        url: receiptFilePath,
        uploadedOn,
        name: receiptFilePath.split("/").pop() || file.name, // Fallback to uploaded file name
      };

      dispatch({ type: UPLOAD_RECEIPT_SUCCESS, payload });
      toast.success("Receipt uploaded successfully.");
      return payload;
    } catch (error) {
      const errorMessage = handleError(error, "uploadReceipt");
      console.error(
        "API - uploadReceipt full error:",
        errorMessage,
        error.response?.data,
        error.response?.status,
        error.response?.headers,
      );
      dispatch({ type: UPLOAD_RECEIPT_FAILURE, payload: errorMessage });
      toast.error(errorMessage);
      throw error;
    }
  };

export const fetchReceipt = (requestId) => async (dispatch) => {
  dispatch({ type: FETCH_RECEIPT_REQUEST });
  try {
    if (!requestId || isNaN(requestId)) {
      throw new Error("Invalid requestId");
    }
    const cleanRequestId = String(requestId).trim();
    const url = `/api/Documents/view-receipt/${cleanRequestId}`;
    console.log("API - fetchReceipt URL:", url);
    const response = await api.get(url, {
      responseType: "blob",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        Accept: "*/* ",
      },
    });
    console.log("API - fetchReceipt response:", {
      status: response.status,
      headers: response.headers,
      dataType: response.data.type,
      dataSize: response.data.size,
    });

    if (!response.data || response.data.size === 0) {
      throw new Error("No receipt data received from the server");
    }

    const contentType = response.data.type;
    let isImage = contentType.startsWith("image/");
    let isPdf = contentType === "application/pdf";
    let inferredType = contentType;
    let filename = null;
    let extension = "";

    // Handle application/octet-stream by inferring from filename
    if (contentType === "application/octet-stream") {
      const disposition = response.headers["content-disposition"];
      console.log("API - fetchReceipt content-disposition:", disposition);
      if (disposition) {
        // Try filename* (UTF-8 encoded)
        const filenameStarMatch = disposition.match(
          /filename\*=UTF-8''(.+?)(?:;|$)/,
        );
        if (filenameStarMatch) {
          filename = decodeURIComponent(filenameStarMatch[1].trim());
          console.log("API - fetchReceipt filename* match:", filename);
        } else {
          // Fallback to filename
          const filenameMatch = disposition.match(
            /filename=["']?([^;"']+)["']?/i,
          );
          filename = filenameMatch ? filenameMatch[1] : null;
          console.log("API - fetchReceipt filename match:", filename);
        }
      }
      filename = filename || `Receipt_${cleanRequestId}`;
      console.log("API - fetchReceipt inferred filename:", filename);

      // Extract extension robustly
      const extensionMatch = filename.match(/\.([a-zA-Z0-9]+)$/i);
      extension = extensionMatch ? extensionMatch[1].toLowerCase() : "png"; // Fallback to png
      console.log("API - fetchReceipt extension:", extension);

      if (extension === "pdf") {
        isPdf = true;
        inferredType = "application/pdf";
      } else if (["png", "jpg", "jpeg", "gif"].includes(extension)) {
        isImage = true;
        inferredType = `image/${extension}`;
      } else {
        console.warn(
          `Cannot infer file type for application/octet-stream with filename: ${filename}. Assuming image/png.`,
        );
        isImage = true;
        inferredType = "image/png";
        extension = "png";
      }
    } else {
      // Infer extension from contentType if not octet-stream
      if (isPdf) {
        extension = "pdf";
      } else if (isImage) {
        extension = contentType.split("/")[1].toLowerCase(); // e.g., "png" from "image/png"
      }
      filename = `Receipt_${cleanRequestId}`;
      console.log(
        "API - fetchReceipt non-octet filename:",
        filename,
        "extension:",
        extension,
      );
    }

    const receiptUrl = URL.createObjectURL(response.data);
    const filenameFinal = `Receipt_${cleanRequestId}.${isPdf ? "pdf" : extension || "png"}`;
    console.log("API - fetchReceipt filenameFinal:", filenameFinal);

    const payload = {
      url: receiptUrl,
      filename: filenameFinal,
      contentType: inferredType,
    };

    console.log("API - fetchReceipt dispatched payload:", payload);
    dispatch({ type: FETCH_RECEIPT_SUCCESS, payload });
    return payload;
  } catch (error) {
    const errorMessage = handleError(error);
    console.error("API - fetchReceipt error:", errorMessage);
    if (error.response?.status === 404) {
      console.warn(
        "API - fetchReceipt: Receipt not found, returning empty payload",
      );
      const payload = { url: null, filename: null, contentType: null };
      dispatch({ type: FETCH_RECEIPT_SUCCESS, payload });
      return payload;
    }
    dispatch({ type: FETCH_RECEIPT_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    throw error;
  }
};

export const updateRequest =
  (requestId, updatedData, requestType) => async (dispatch) => {
    dispatch({ type: UPDATE_REQUEST_REQUEST });
    const normalizedType = normalizeRequestType(requestType);
    const endpoint = requestTypeRoutes[normalizedType];
    console.log(
      "updateRequest - Request Type:",
      requestType,
      "Normalized:",
      normalizedType,
    );
    console.log("updateRequest - Endpoint:", endpoint, "requestId:", requestId);

    if (!endpoint) {
      const errorMessage = `Invalid request type: ${requestType}`;
      console.error(errorMessage);
      dispatch({ type: UPDATE_REQUEST_FAILURE, payload: errorMessage });
      toast.error(errorMessage);
      return;
    }

    try {
      console.log(`API - updateRequest for ${endpoint}/${requestId}`);
      const response = await api.put(`${endpoint}/${requestId}`, updatedData, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      console.log("API - updateRequest response:", response.data);
      dispatch({ type: UPDATE_REQUEST_SUCCESS, payload: response.data });
      toast.success("Request updated successfully");
      return response.data;
    } catch (error) {
      const errorMessage = handleError(error, "updateRequest");
      dispatch({ type: UPDATE_REQUEST_FAILURE, payload: errorMessage });
      toast.error("Failed to update request: " + errorMessage);
      throw error;
    }
  };

export const deleteRequest = (requestId, requestType) => async (dispatch) => {
  dispatch({ type: DELETE_REQUEST_REQUEST });
  const normalizedType = normalizeRequestType(requestType);
  console.log(
    "deleteRequest - Request Type:",
    requestType,
    "Normalized:",
    normalizedType,
  );
  const endpoint = requestTypeRoutes[normalizedType];
  console.log("deleteRequest - Endpoint:", endpoint, "requestId:", requestId);

  if (!endpoint) {
    const errorMessage = `Invalid request type: ${requestType}`;
    console.error(errorMessage);
    dispatch({ type: DELETE_REQUEST_FAILURE, payload: errorMessage });
    toast.error(errorMessage);
    return;
  }

  try {
    console.log(`API - deleteRequest for ${endpoint}/${requestId}`);
    await api.delete(`${endpoint}/${requestId}`, {
      headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
    });
    console.log("API - deleteRequest success");
    dispatch({ type: DELETE_REQUEST_SUCCESS, payload: requestId });
    toast.success("Request deleted successfully");
  } catch (error) {
    const errorMessage = handleError(error, "deleteRequest");
    dispatch({ type: DELETE_REQUEST_FAILURE, payload: errorMessage });
    toast.error("Failed to delete request: " + errorMessage);
    throw error;
  }
};

export const approveReceipt = (requestId) => async (dispatch) => {
  dispatch({ type: APPROVE_RECEIPT_REQUEST });
  try {
    console.log(
      `API - approveReceipt for RequestSetting/approve-receipt/${requestId}`,
    );
    const response = await api.post(
      `/RequestSetting/approve-receipt/${requestId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "*/*",
        },
      },
    );
    console.log("API - approveReceipt response:", response.data);
    dispatch({
      type: APPROVE_RECEIPT_SUCCESS,
      payload: { requestId, data: response.data },
    });
    toast.success("Receipt approved successfully");
    // Refresh the pending receipts list
    dispatch(fetchPendingReceiptUploads());
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "approveReceipt");
    dispatch({
      type: APPROVE_RECEIPT_FAILURE,
      payload: errorMessage,
    });
    toast.error("Failed to approve receipt: " + errorMessage);
    throw error;
  }
};

export const requireReceipt = (requestId) => async (dispatch) => {
  dispatch({ type: REQUIRE_RECEIPT_REQUEST });
  try {
    console.log(
      `API - requireReceipt for /PaymentVoucher/${requestId}/requires-receipt`,
    );
    const response = await api.patch(
      `/PaymentVoucher/${requestId}/requires-receipt`,
      { requiresReceipt: true },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "*/*",
          "Content-Type": "application/json-patch+json",
        },
      },
    );
    console.log("API - requireReceipt response:", response.data);
    dispatch({
      type: REQUIRE_RECEIPT_SUCCESS, // Consider renaming to REQUIRE_RECEIPT_SUCCESS for clarity
      payload: { requestId, data: response.data },
    });
    toast.success("Receipt requirement set successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "requireReceipt");
    dispatch({
      type: REQUIRE_RECEIPT_FAILURE, // Consider renaming to REQUIRE_RECEIPT_FAILURE
      payload: errorMessage,
    });
    toast.error("Failed to set receipt requirement: " + errorMessage);
    throw error;
  }
};

export const recallRequest = (requestId) => async (dispatch) => {
  dispatch({ type: RECALL_REQUEST_REQUEST });
  try {
    console.log(`API - recallRequest for /PaymentVoucher/${requestId}/recall`);
    const response = await api.post(
      `/PaymentVoucher/${requestId}/recall`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "*/*",
        },
      },
    );
    console.log("API - recallRequest response:", response.data);
    dispatch({
      type: RECALL_REQUEST_SUCCESS,
      payload: { requestId, data: response.data },
    });
    toast.success("Request recalled successfully");
    return response.data;
  } catch (error) {
    const errorMessage = handleError(error, "recallRequest");
    dispatch({
      type: RECALL_REQUEST_FAILURE,
      payload: errorMessage,
    });
    toast.error("Failed to recall request: " + errorMessage);
    throw error;
  }
};

export const clearRequestsError = () => ({
  type: CLEAR_REQUESTS_ERROR,
});
